export const myObjectStatuses = ['active', 'submitted', 'cancelled'] as const

export type MyObjectStatus = (typeof myObjectStatuses)[number]

export interface MyObject {
  id: string
  title: string
  address: string
  price: number
  startDate?: string
  endDate?: string
  status: MyObjectStatus
  statusLabel: string
  rejectionReason: string | null
  moderationStatus: string | null
}
